export default {"src":"/_next/static/media/aiOptOut-logo.567b736a.svg","height":130,"width":152,"blurWidth":0,"blurHeight":0};